import { MenuItem as MuiMenuItem } from '@mui/material';
import type { MenuItemProps as MuiMenuItemProps } from '@mui/material/MenuItem';
import type { SxProps, Theme } from '@mui/material/styles';

export type MenuItemProps = MuiMenuItemProps;

export const MenuItem = ({ sx, ...rest }: MenuItemProps): JSX.Element => {
  const baseSx: SxProps<Theme> = (theme) => ({
    fontSize: theme.typography.body2.fontSize,
    lineHeight: theme.typography.body2.lineHeight,
    fontWeight: theme.typography.body2.fontWeight,
    paddingX: theme.app.spacing.xxs,
    '& .MuiTypography-root, & span': {
      fontSize: theme.typography.body2.fontSize,
      lineHeight: theme.typography.body2.lineHeight,
      fontWeight: theme.typography.body2.fontWeight,
    },
  });
  const resolvedSx = sx ? [baseSx, ...(Array.isArray(sx) ? sx : [sx])] : baseSx;
  return <MuiMenuItem sx={resolvedSx} {...rest} />;
};
